























































import { LessonMessageService } from "../../biz/remote/LessonMessageService";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { LessonMessageDTO } from "../../../src_server/entity/dto/LessonMessageDTO";
import {
  dayjs,
  DTW_FORMAT_JA_WO_YM,
  DTW_FORMAT_JA_SHORT,
} from "../../../src_server/common/momentExtends";
import { MessageDialog } from "../../utils/MessageDialog";
import PageNation from "../organisms/PageNation.vue";
import EmergencyMessageDialog from "./EmergencyMessageDialog.vue";
import LessonMessageDialog from "./LessonMessageDialog.vue";
import { NotifyLogs } from "../../../src_server/entity/generated/NotifyLogs";
import { Session } from "../../utils/Session";
import TeacherContactSection from "./TeacherContactSection.vue";

class SumLessonMessageDTO {
  messageCount = 0;
  class_id?: number;
  lastSendDate?: Date;
  lessonMessages: LessonMessageDTO[] = [];
  fromUserName = "";
  teacher_user_id = "";
  student_user_id = "";
  opponentUserId = "";
  opened = false;
  get notReadCount() {
    return this.lessonMessages.reduce((a, c) => {
      if (c.messages.from_user_id === Session.getSessionUserId()) return a;
      return a + (c.messages.read_yet ? 0 : 1);
    }, 0);
  }
  isSystem = false;
  get title() {
    if (this.class_id === 0) {
      return `${this.fromUserName}さんとのレッスン以外の連絡`;
    } else if (this.class_id === -1) {
      return `${this.fromUserName}`;
    } else {
      return `${this.fromUserName}さんとの${dayjs(this.lastSendDate).format(
        DTW_FORMAT_JA_SHORT
      )}開始のレッスン(ID:${this.class_id})についての連絡`;
    }
  }
}
@Component({
  components: {
    PageNation,
    EmergencyMessageDialog,
    LessonMessageDialog,
    TeacherContactSection,
  },
  filters: {
    dateFormat: (dt: Date) => {
      return dayjs(dt).format(DTW_FORMAT_JA_SHORT);
    },
    dtFormat: (dt: Date) => {
      return dayjs(dt).format(DTW_FORMAT_JA_WO_YM);
    },
    trimMessage(content: string) {
      return content.split(`----`)[1];
    },
    trimSystemMessage(content: string) {
      return content.split(`---`)[1];
    },
  },
})
export default class LessonMessages extends Vue {
  private loading = false;
  private originalMessages: LessonMessageDTO[] = [];
  private messages: SumLessonMessageDTO[] = [];
  private dispRows: SumLessonMessageDTO[] = [];
  private notifyLogs: NotifyLogs[] = [];

  @Prop({
    required: true,
    default: () => {
      return Session.getSessionUserId();
    },
  })
  ownerUserId!: string;

  @Prop({
    required: true,
    default: () => {
      return Session.getSessionUserType();
    },
  })
  ownerUserType!: string;

  @Prop({ default: false })
  readonly!: boolean;

  openGroup(m: SumLessonMessageDTO) {
    m.opened = m.opened ? false : true;

    // 既読にする
    this.toReadYet(m).then();
  }

  async toReadYet(m: SumLessonMessageDTO) {
    const biz = new LessonMessageService();
    await biz.readYetMessage(
      Session.getSessionUserId(),
      m.lessonMessages.map((m) => m.messages.message_id!)
    );
  }

  isNewMessage(m: LessonMessageDTO) {
    console.log(
      "is new ",
      m.messages.from_user_id,
      Session.getSessionUserId(),
      m.messages.read_yet,
      m.messages.from_user_id !== Session.getSessionUserId() && !m.messages.read_yet
    );
    return m.messages.from_user_id !== Session.getSessionUserId() && !m.messages.read_yet;
  }

  getFromName(item: LessonMessageDTO) {
    return item.messages.from_user_id === item.messages.student_user_id
      ? item.student.nickname
      : item.teacher.nickname;
  }

  async pageChanged(rows: SumLessonMessageDTO[]) {
    this.dispRows = rows;
  }

  async openEmergencyMessageByID(teacher_user_id: string, student_user_id: string) {
    const dialog: LessonMessageDialog = this.$refs[
      "LessonMessageDialog"
    ] as LessonMessageDialog;
    await dialog.show(teacher_user_id, student_user_id);
  }

  async openEmergencyMessage(row: SumLessonMessageDTO) {
    const class_id = row.class_id!;
    if (class_id === 0) {
      const dialog: LessonMessageDialog = this.$refs[
        "LessonMessageDialog"
      ] as LessonMessageDialog;
      await dialog.show(row.teacher_user_id, row.student_user_id);
    } else {
      const dialog: EmergencyMessageDialog = this.$refs[
        "emergency_message_dialog"
      ] as EmergencyMessageDialog;
      await dialog.show(class_id);
    }
  }

  send(dto: LessonMessageDTO) {
    console.log("dend", dto);
    this.originalMessages.push(dto);
    this.originalMessages.sort((a, b) =>
      dayjs(b.messages.class_id).diff(dayjs(b.messages.class_id))
    );
  }

  /**
   * レッスンのメッセージをマージする
   */
  sumLessonMessage(found: SumLessonMessageDTO, cur: LessonMessageDTO) {
    found.messageCount += 1;
    found.lessonMessages.push(cur);
    found.lessonMessages.sort((a, b) =>
      dayjs(b.messages.send_dt).diff(dayjs(a.messages.send_dt))
    );
    if (!found.lastSendDate || !cur.messages.send_dt) {
      MessageDialog.systemError("最終更新日/送信日時", "メッセージ集約時").then();
      return;
    }
    found.lastSendDate =
      found.lastSendDate < cur.messages.send_dt
        ? cur.messages.send_dt
        : found.lastSendDate;
  }

  /**
   * 統合したメッセージヘッダを新規作成して返す
   */
  getNewSumLessonMessage(cur: LessonMessageDTO) {
    const sum = new SumLessonMessageDTO();
    Object.assign(sum, cur);
    sum.messageCount = 1;
    sum.class_id = cur.messages.class_id;
    sum.lastSendDate = cur.messages.send_dt;
    sum.opponentUserId = this.getOpponentUserID(cur);
    sum.lessonMessages.push(cur);
    sum.teacher_user_id = cur.messages.teacher_user_id!;
    sum.student_user_id = cur.messages.student_user_id!;
    sum.fromUserName =
      this.ownerUserId === cur.messages.student_user_id
        ? cur.teacher.nickname!
        : cur.student.nickname!;
    return sum;
  }

  getSystemNotifyLogs(notifyLogs: NotifyLogs[]) {
    const systemNotifyLogs = new SumLessonMessageDTO();
    systemNotifyLogs.class_id = -1;
    systemNotifyLogs.fromUserName = "システム通知";
    systemNotifyLogs.isSystem = true;
    systemNotifyLogs.lessonMessages = notifyLogs.map((n) => {
      const dto = new LessonMessageDTO();
      dto.messages.message_id = n.notify_log_id;
      dto.messages.message_contents = n.message;
      dto.messages.send_dt = n.notify_dt;
      dto.messages.class_id = -1;
      dto.messages.student_user_id = n.user_id;
      dto.messages.teacher_user_id = n.user_id;
      dto.messages.from_user_id = n.user_id;
      systemNotifyLogs.messageCount += 1;
      if (dayjs(systemNotifyLogs.lastSendDate).diff(dayjs(n.notify_dt)) > 0) {
        systemNotifyLogs.lastSendDate = n.notify_dt;
      }
      return dto;
    });
    return systemNotifyLogs;
  }

  getOpponentUserID(cur: LessonMessageDTO) {
    return cur.messages.student_user_id === this.ownerUserId
      ? cur.messages.teacher_user_id!
      : cur.messages.student_user_id!;
  }

  @Watch("originalMessages", { deep: true, immediate: true })
  async reLoadData() {
    this.loadData(this.originalMessages, this.notifyLogs);
    this.loading = false;
  }

  /**
   * レッスンに紐づく緊急メッセージ
   * レッスンに紐づかない、枠調整メッセージ
   * システム通知を1つのリストにまとめてそーと
   *
   */
  async loadData(originalMessages: LessonMessageDTO[], notifyLogs: NotifyLogs[]) {
    // console.log('loadData', originalMessages, notifyLogs);
    this.loading = true;

    let noLessonMessages: SumLessonMessageDTO[] = [];
    let lessonMessages: SumLessonMessageDTO[] = [];
    if (originalMessages && originalMessages.length > 0) {
      /**
       * レッスンに紐づかないメッセージ(ユーザー毎のメッセージとする)
       */
      noLessonMessages = originalMessages
        .filter((m) => m.messages.class_id === 0)
        .reduce((prev: SumLessonMessageDTO[], cur: LessonMessageDTO) => {
          // クラスIDを発見したら統合、なかったら新しく作る
          const found = prev.find(
            (m) => m.opponentUserId === this.getOpponentUserID(cur)
          );
          found
            ? this.sumLessonMessage(found, cur)
            : prev.push(this.getNewSumLessonMessage(cur));
          return prev;
        }, new Array<SumLessonMessageDTO>());

      /**
       * レッスンに紐づいたメッセージ
       */
      lessonMessages = originalMessages
        .filter((m) => m.messages.class_id !== 0)
        .reduce((prev: SumLessonMessageDTO[], cur: LessonMessageDTO) => {
          // クラスIDを発見したら統合、なかったら新しく作る
          const found = prev.find((m) => m.class_id === cur.messages.class_id);
          found
            ? this.sumLessonMessage(found, cur)
            : prev.push(this.getNewSumLessonMessage(cur));
          return prev;
        }, new Array<SumLessonMessageDTO>());
    }

    // メッセージを統合
    this.messages = noLessonMessages.concat(lessonMessages);

    // システム通知ログを表示用にまとめる。
    const systemNotifyLogs = this.getSystemNotifyLogs(notifyLogs);
    console.log("systemNotifyLogs", systemNotifyLogs);
    if (systemNotifyLogs.messageCount > 0) {
      this.messages.push(systemNotifyLogs);
    }

    // 全てのメッセージをソート
    this.messages = this.messages.sort((a, b) => {
      if (!a.lastSendDate || !b.lastSendDate) return 0;
      return dayjs(b.lastSendDate).diff(dayjs(a.lastSendDate));
    });

    if (!this.messages || this.messages.length === 0) {
      this.loading = false;
      return;
    }

    this.loading = false;
  }

  async created() {
    this.loading = true;

    const biz = new LessonMessageService();
    const response = await biz.getMessages(this.ownerUserId, this.ownerUserType);
    this.originalMessages = response.data;

    const notifyLogsResponse = await biz.getSystemNotify(this.ownerUserId);
    this.notifyLogs = notifyLogsResponse.data;

    await this.loadData(this.originalMessages, this.notifyLogs);
    this.loading = false;
  }
}
